import React, { Component } from 'react'
import shortid from 'shortid'

import './Tabs.css';

class Tabs extends Component {

  constructor(props){
    super(props);

    this.state = {
      items: props.items,
      value: props.value,
      size: props.size,
      disabled: props.disabled
    }
  }

  componentWillReceiveProps(newProps){
    this.setState({
      items: newProps.items,
      value: newProps.value,
      size: newProps.size,
      disabled: newProps.disabled
    })
  }

  render(){
    const state = this.state;
    const props = this.props;

    var items = [];
    var current_index = 0;

    for(var i in state.items){
      if(typeof state.items[i] === 'string'){
        items.push({
          display: state.items[i],
          value: state.items[i],
          disabled: false
        })
      } else if(typeof state.items[i] === 'object'){
        items.push(state.items[i]);
      }

      if(state.value === items[i].value){
        current_index = parseInt(i, 10);
      }
    }

    var barPosition = 0;
    if(state.size === 'large') barPosition = current_index * 125;
    if(state.size === 'medium') barPosition = current_index * 90;
    if(state.size === 'small') barPosition = current_index * 40;


    return <div 
      className={
        "tabs" + 
        (props.marginBottom ? " tab-margin-bottom" : "") + 
        (state.disabled ? " tabs-disabled" : "")
      }
      onMouseEnter={this.props.onMouseEnter}
      onMouseLeave={this.props.onMouseLeave}
      >
      
      <div className="tab-bg-list">
        {
          items.map(function(t, i){
            return <div 
              key={i} 
              className={
                "tab-btn tab-item " + 
                ( t.disabled ? "tab-btn-disabled" : "" ) + 
                (state.size === 'large' ? " tab-item-lg" : "") + 
                (state.size === 'medium' ? " tab-item-md" : "") + 
                (state.size === 'small' ? " tab-item-sm" : "")
              } 
              onMouseEnter={(e)=>{ e.stopPropagation(); e.preventDefault(); }}
              onClick={(e) => { 
                if(items.length > 2 || current_index !== i) return props.onChange(t);
                return props.onChange(i === 0 ? items[1]:items[0]);
              }}>
              <span key={shortid.generate()}>
                {t.display || t.value}
              </span>
            </div>
          })
        }
      </div>
      <div style={{left: barPosition, color: items[current_index].color}} className={
        "tab-bar tab-item " + 
        (state.disabled ? "tab-bar-disabled" : "" ) + 
        (state.size === 'large' ? " tab-item-lg" : "") + 
        (state.size === 'medium' ? " tab-item-md" : "") + 
        (state.size === 'small' ? " tab-item-sm" : "")
      } >
        <span key={current_index}>
          <span className="tab-bar-label">{items[current_index].display || items[current_index].value}</span>
          {/*<span className="tab-bar-checkmark"><i className="far fa-check text-success"/></span>*/}
        </span>
      </div>
    </div>
  }
}

export default Tabs;


// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.js